import { useQuery } from '@tanstack/react-query';

import { companiesListQuery } from '@/entities/company/queries';
import { ICompanyDto } from '@/shared/api/companies';

export function useCompaniesList(enabled: boolean = true) {
  const { data, ...otherQueryData } = useQuery<ICompanyDto[]>({
    ...companiesListQuery(),
    enabled,
    retry: 3,
  });

  return { companies: data?.length ? data : undefined, ...otherQueryData };
}
